
<form [formGroup]="GroupForm">

    <div class="modal-header">
        <h4 class="modal-title ">Añadir / Modificar Grupos</h4>
       
    </div>
    <div class="modal-body scrollable">
        <div class="row">
            <div class="mt-2 col-xl-6 col-lg-6 col-md-12 col-xs-12">
                Nombre del Grupo <small class="text-danger"></small>
                <input type="text" class="form-control form-control-sm" formControlName="name" name="name" placeholder="Nombre del Grupo">
            </div>
            <div class="mt-2 col-xl-4 col-lg-6 col-md-6 col-xs-12">
                Póliza Permitida <small class="text-danger"></small>
                <ng-select [items]="listPolicies" formControlName="policyId" bindLabel="code" bindValue="_id" [clearable]="true" appendTo="body" dropdownPosition="auto"></ng-select>
               
            </div>
            <div class="mt-2 col-xl-4 col-lg-6 col-md-6 col-xs-12">
                Campo <small class="text-danger"></small>
               <ng-select [items]="listCampus" formControlName="campusId" bindLabel="acronym" bindValue="_id" [clearable]="true" appendTo="body" dropdownPosition="auto"></ng-select>
            </div>
            <div class="mt-4 col-lg-4 col-md-4 col-xs-12 d-flex align-items-center">
                <div class="form-check form-switch">
                    <input #checkActive class="form-check-input" type="checkbox" role="switch" id="checkActive" formControlName="enabled">
                    <label class="form-check-label" for="checkActive">Activo</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- @if(permissions?.search.save){ -->
        <button class="btn btn-primary btn-sm" [disabled]="GroupForm.invalid"  (click)="submit()"> Guardar</button>
        <!-- } -->
    </div>


</form>
